import { createRouter, createWebHistory } from 'vue-router'
import { routes } from './routes'
import { setupRouterGuard } from './guard'
export * from './routes'

// app router
export const router = createRouter({
  history: createWebHistory(),
  routes,

  scrollBehavior() {
    return { left: 0, top: 0 }
  },
})
setupRouterGuard(router)
